import React from 'react';
import styles from './systemMessage.module.scss';
import InfoIcon from '../../icon/InfoIcon';
import { H2, H4 } from '../../../text';

type SystemMessageProps = {
  title?: string,
  message?: string,
  icon?: JSX.Element
}

/**
 * An in-page system message for page-level alerts 
 * @param {string} [props.title]
 * @param {string} [props.message]
 * @param {JSX.Element} [props.icon]
 * @returns {JSX.Element}
 */
const SystemMessage: React.FC<SystemMessageProps> = ({ title = 'System message', message = 'This is a system message', icon = InfoIcon.BLOCKED }) => (
  <div className={styles.harness}>
    <div className={styles.icon}>{icon}</div>
    <H2>{title}</H2>
    <H4>{message}</H4>
  </div>
);

export default SystemMessage;